import { http } from "wagmi"
import { base } from "wagmi/chains"

import type { ChainConfig } from "@/domains/core"
import { appConfig } from "@/config/app-config"
import { loadBalance } from "@/lib/load-balance"

// Default RPC URLs (fallback if env var not set)
const defaultBaseRpcUrls = [
  // "https://rpc.ankr.com/base/129d5432456aab10e3d5b5cf080e980ed683b3b7335493310ca4d5bd52387617",
  // Public Scale endpoint
  "https://base.blockpi.network/v1/rpc/597d6c6fbfb4778b677c141c94b044d35c040be2",
  // Private scale endpoint
  // "https://base.blockpi.network/v1/rpc/6d984058cd2b86f3a4d537fa0e0b0dcf9448f9b1",
  // "https://base.llamarpc.com",
  // "https://base-pokt.nodies.app",
  // "https://base-rpc.publicnode.com",
  // "https://0xrpc.io/base",
  // "https://mainnet.base.org",
]

export const BASE_DEFAULT_RPC = "https://base.blockpi.network/v1/rpc/597d6c6fbfb4778b677c141c94b044d35c040be2"
/**
 * Get RPC URLs for Base chain from environment variable or fallback to defaults
 * Supports comma-separated multiple URLs in VITE_RPC_URL
 */
function getBaseRpcUrls(): string[] {
  // Vite uses import.meta.env for environment variables
  const envRpcUrl = import.meta.env.VITE_RPC_URL

  if (envRpcUrl) {
    // Split by comma and trim whitespace
    const urls = (envRpcUrl as string)
      .split(",")
      .map((url: string) => url.trim())
      .filter(Boolean) as string[]
    if (urls.length > 0) {
      return urls
    }
  }

  return defaultBaseRpcUrls
}

export const providersPerChain = {
  [base.id]: getBaseRpcUrls(),
} as const satisfies Record<number, string[]>

export const supportedChains = [base]

const baseTransport = loadBalance(providersPerChain[base.id].map((v) => http(v)))

// Use static config instead of next/config
const chainConfig: ChainConfig = appConfig

export function getChainFromConfig() {
  const chain = chainConfig.chainId
  if (!chain) throw new Error("chainConfig.chainId value is missing")
  if (typeof chain !== "number") throw new Error("Invalid chainConfig.chainId value type")
  if (chain === base.id) return base
  throw new Error("Invalid chainConfig value")
}

export function getTransportFromConfig(): Record<number, ReturnType<typeof loadBalance>> {
  const chain = chainConfig.chainId
  if (!chain) throw new Error("chainConfig.chainId value is missing")
  if (typeof chain !== "number") throw new Error("Invalid chainConfig.chainId value type")

  if (chain === base.id) {
    return {
      [base.id]: baseTransport,
    }
  }
  throw new Error("Invalid chain")
}

export const baseDeploymentInfo = {
  name: "SCALE",
  url: "https://scale.farm",
}

export function getDeploymentInfoByChainID(id: number) {
  if (id === base.id) return baseDeploymentInfo

  return null
}

export { chainConfig }
